import { defineStore } from 'pinia';

import { apiClient } from '@/Clients/ApiClient';
import UsersService from '@/Services/UsersService';

const usersService = new UsersService(apiClient);

export const useBackerCenterPaymentsStore = defineStore(
    'backerCenterPayments', {
        state: () => ({
            paymentsData: {},
            paymentsItems: [],
            isLoaded: false,
            isLoadingMore: false,
        }),
        actions: {
            async loadPayments(params = {}, loadMore = false) {
                try {
                    this.isLoaded = false;
                    this.isLoadingMore = loadMore;
                    const { data } = await usersService.getBackerPayments(params);
                    this.paymentsData = data.pagedPayments;
                    if (loadMore) {
                        this.paymentsItems = [...this.paymentsItems, ...data.pagedPayments.pagedItems];
                    }
                    else {
                        this.paymentsItems = data.pagedPayments.pagedItems;
                    }
                    this.isLoaded = true;
                    this.isLoadingMore = false;
                    return data;
                }
                catch (error) {
                    throw new Error(error);
                }
            },
            resetPaymentsData() {
                this.paymentsData = {};
                this.paymentsItems = [];
                this.isLoaded = false;
                this.isLoadingMore = false;
            },
        },
        getters: {
            hasPayments(state) {
                return state.paymentsItems.length > 0;
            },
        },
    });